import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import './i18n';
import App from './App';

const apiBase = process.env.REACT_APP_API_URL;
if (apiBase) {
  axios.defaults.baseURL = apiBase.replace(/\/$/, '');
  axios.defaults.headers.common['X-Forwarded-Host'] = window.location.hostname;
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 429) {
      error.userMessage = error.response?.data?.error
        || 'Too many requests. Please try again later.';
    }
    return Promise.reject(error);
  },
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
